/* tslint:disable */
/* eslint-disable */
/**
 * Integrations Service
 * Provides an API to integrate with various 3rd party integrations
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExtraFieldDto } from './ExtraFieldDto';
import {
    ExtraFieldDtoFromJSON,
    ExtraFieldDtoFromJSONTyped,
    ExtraFieldDtoToJSON,
} from './ExtraFieldDto';

/**
 * 
 * @export
 * @interface UpdateParagonExtrasRequest
 */
export interface UpdateParagonExtrasRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateParagonExtrasRequest
     */
    providerType: UpdateParagonExtrasRequestProviderTypeEnum;
    /**
     * 
     * @type {Array<ExtraFieldDto>}
     * @memberof UpdateParagonExtrasRequest
     */
    extraFields: Array<ExtraFieldDto>;
}


/**
 * @export
 */
export const UpdateParagonExtrasRequestProviderTypeEnum = {
    Dynamics: 'DYNAMICS',
    Hubspot: 'HUBSPOT',
    Salesforce: 'SALESFORCE',
    Zoho: 'ZOHO'
} as const;
export type UpdateParagonExtrasRequestProviderTypeEnum = typeof UpdateParagonExtrasRequestProviderTypeEnum[keyof typeof UpdateParagonExtrasRequestProviderTypeEnum];


/**
 * Check if a given object implements the UpdateParagonExtrasRequest interface.
 */
export function instanceOfUpdateParagonExtrasRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "providerType" in value;
    isInstance = isInstance && "extraFields" in value;

    return isInstance;
}

export function UpdateParagonExtrasRequestFromJSON(json: any): UpdateParagonExtrasRequest {
    return UpdateParagonExtrasRequestFromJSONTyped(json, false);
}

export function UpdateParagonExtrasRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateParagonExtrasRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'providerType': json['providerType'],
        'extraFields': ((json['extraFields'] as Array<any>).map(ExtraFieldDtoFromJSON)),
    };
}

export function UpdateParagonExtrasRequestToJSON(value?: UpdateParagonExtrasRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'providerType': value.providerType,
        'extraFields': ((value.extraFields as Array<any>).map(ExtraFieldDtoToJSON)),
    };
}

